import React, { Suspense, lazy } from "react";
import { motion } from "framer-motion";
import { TrendingUp, Dumbbell, Scale, Flame } from "lucide-react";

const AnalyticsCharts = lazy(() => import("@/components/landing/AnalyticsCharts"));

const stats = [
  { icon: Flame, label: "Day Streak", value: "47" },
  { icon: TrendingUp, label: "Strength Gain", value: "+34%" },
  { icon: Scale, label: "Weight Lost", value: "12 lb" },
  { icon: Dumbbell, label: "Workouts Done", value: "312" },
];

const ChartFallback = () => (
  <div className="space-y-6">
    <div className="h-40 rounded-xl bg-white/5 animate-pulse" />
    <div className="h-36 rounded-xl bg-white/5 animate-pulse" />
  </div>
);

export const AnalyticsSection = () => {
  return (
    <section id="analytics" data-testid="analytics-section" className="relative py-24 md:py-32 bg-obsidian">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-vitality">Progress Analytics</span>
            <h2 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight mt-4 leading-tight">
              Visualize Every Victory
            </h2>
            <p className="text-white/60 mt-4 text-lg leading-relaxed">
              Track your transformation with smart, intuitive analytics. Dynamic charts for weight, strength and
              measurements, plus weekly reports that keep you on track and motivated.
            </p>

            <div className="grid grid-cols-2 gap-4 mt-8">
              {stats.map((s) => (
                <div key={s.label} data-testid={`stat-${s.label}`} className="glass rounded-xl p-5 flex items-center gap-4">
                  <div className="w-11 h-11 rounded-lg bg-vitality/10 flex items-center justify-center">
                    <s.icon className="w-5 h-5 text-vitality" />
                  </div>
                  <div>
                    <div className="font-heading text-3xl font-black text-white leading-none">{s.value}</div>
                    <div className="text-xs uppercase tracking-wider text-white/50 mt-1">{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="glass rounded-3xl p-6 md:p-8 space-y-6"
          >
            <Suspense fallback={<ChartFallback />}>
              <AnalyticsCharts />
            </Suspense>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
